export const ROLE_BASIC_RECORDS = 'basicrecords';
export const ROLE_TRAVEL_ADMIN = 'traveladmin';
export const ROLE_MANAGER = 'manager';
export const ROLE_FINANCE = 'finance';
export const ROLE_DEAN = 'dean';
export const ROLE_HR = 'hr';
export const ROLE_DB_ADMIN = 'dbadmin';
export const ROLE_CRISIS_TEAM = 'crisisteam';
export const ROLE_PHONE = 'phone';
export const ROLE_USER = 'user';
export const ROLE_HOUSING = 'housing';
export const ROLE_REPORTS = 'reports';

export interface AuthStateModel {
	netId: string;
	userId: number;
	loggedIn: boolean;
	errorMessage: string;
	roles: string[];
	redirectUrl: string;
}
